import { BookingRewireDataType } from "../../../../Models/BookingRewireDataType";
import { COLORS } from "../constants";
import { BookingEntry, EventData, ResourceData } from "../types";

export const getInventoryIdFromEntry = (entry: BookingEntry): string => {
  // Try direct inventoryId first (BookingRewireData format)
  if (entry.inventoryId) {
    return entry.inventoryId;
  }
  // Try resource field (BookingApprovalInfo format)
  if (entry.resource) {
    return entry.resource as string;
  }
  // Try nested equipment.inventoryId
  if (entry.equipment?.inventoryId) {
    return entry.equipment.inventoryId;
  }
  // Fallback to id
  return entry.id;
};

export const createResources = (booking: BookingRewireDataType | null): ResourceData[] => {
  if (!booking?.bookingEntries?.length) return [];

  // Deduplicate resources by inventoryId
  const uniqueInventoryIds = new Set<string>();
  const resources: ResourceData[] = [];

  booking.bookingEntries.forEach((entry: BookingEntry) => {
    const inventoryId = getInventoryIdFromEntry(entry);

    if (!uniqueInventoryIds.has(inventoryId)) {
      uniqueInventoryIds.add(inventoryId);

      resources.push({
        id: inventoryId,
        name: entry.equipment?.shortIdentifier || entry.equipment?.equipmentModel || inventoryId,
        color: "#4981d6",
        eventOverlap: false,
        depth: 0,
        isParent: false,
        eventDragInTime: true,
        eventResize: true,
      });
    }
  });

  return resources;
};

export const createCurrentBookingEvents = (booking: BookingRewireDataType | null): EventData[] => {
  if (!booking?.bookingEntries?.length) return [];

  return booking.bookingEntries.map((entry: BookingEntry) => {
    const inventoryId = getInventoryIdFromEntry(entry);

    return {
      id: entry.id,
      start: entry.start,
      end: entry.end,
      resource: inventoryId,  // Use resolved inventoryId
      title: entry.type || booking.type,
      type: entry.type || booking.type,
      color: COLORS.currentBooking.background,
      fcolor: COLORS.currentBooking.text,
      editable: true,
      isCurrentBooking: true,
      active: entry.active,
      bookingId: entry.bookingId,
      inventoryId: inventoryId,  // Use resolved inventoryId
    };
  });
};


export const transformOtherBookingEntries = (
  entries: BookingEntry[],
  excludeBookingId: string | null,
  queryInventoryId: string,
): EventData[] => {
  return entries
    .filter((entry) => entry.active && entry.bookingId !== excludeBookingId)
    .map((entry) => {
      const resourceId = entry.inventoryId || queryInventoryId;
      return {
        id: entry.id,
        start: entry.start,
        end: entry.end,
        resource: resourceId,
        title: entry.type,
        type: entry.type,
        color: COLORS.otherBooking.background,
        fcolor: COLORS.otherBooking.text,
        editable: false,
        isCurrentBooking: false,
        bookingId: entry.bookingId,
        inventoryId: resourceId,
        overlap: false,
      };
    });
};
